import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axiosService from '../../../utils/AxiosService'
import Input from '../../FormComponents/Input'
import Checkbox from '../../FormComponents/Checkbox'
import { toastError } from '../../FormComponents/Toasts'
import { EditProjectManagerSchema } from '../../../schemas/ProjectManager/EditProjectManagerSchema'
import ProjectManager from '../../../models/ProjectManager'

export default function EditProjectManager() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [projectManager, setProjectManager] = useState(new ProjectManager())
  const [loading, setLoading] = useState(false)

  useEffect(() => getProjectManager(), [])

  const getProjectManager = () => {
    setLoading(true)
    axiosService.get(`/api/project_manager/project_managers/${id}`)
    .then(project_manager => {
      setProjectManager(new ProjectManager(project_manager))
      setTimeout(() => setLoading(false), 1000)
    })
    .catch(error => console.log(error))
  }

  const updateProjectManager = project_manager => {
    axiosService.patch(`/api/project_manager/project_managers/${id}`, { project_manager })
    .then(() => navigate('/project_manager/project-managers'))
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <div className="pt-12 bg-white dark:bg-rb-dark-mode min-h-screen">
      <div className="flex items-center justify-between w-full h-20 px-24 align-center bg-gradient-to-br from-rb-green from-30% via-teal-500 via-60% to-rb-green to-90%">
        <p className="text-white text-2xl">
          Edit Project Manager
        </p>
      </div>

      <div className="px-24 pt-10">
        <Formik
          initialValues={projectManager}
          validationSchema={EditProjectManagerSchema}
          onSubmit={updateProjectManager}
          enableReinitialize={loading}
        >
          {({ errors, touched, handleBlur, handleChange, values }) => (
            <Form>
              <div className="form-item-container w-full">
                <div className="w-80">
                  <Input error={touched.first_name && errors.first_name} label="First Name" name="first_name" onChange={handleChange} onBlur={handleBlur} value={values.first_name} />
                  <Input error={touched.last_name && errors.last_name} label="Last Name" name="last_name" onChange={handleChange} onBlur={handleBlur} value={values.last_name} />
                  <Input error={touched.email && errors.email} label="Email" name="email" onChange={handleChange} onBlur={handleBlur} value={values.email} />
                  <Checkbox label="Admin" name="is_admin" onChange={handleChange} onBlur={handleBlur} checked={values.is_admin} />
                </div>
              </div>
              <div className="flex">
                <button
                  type="submit"
                  className="submit text-left w-full text-rb-green dark:text-rb-green border-2 rounded-full w-60 py-4 text-center active:shadow-outer active:shadow-rb-green border-rb-green dark:border-rb-green dark:bg-rb-dark-mode-lighter dark:text-white"
                >
                  Update Project Manager
                </button>
                <button
                  type="button"
                  className="rb-btn-cancel text-left w-full rounded-full w-60 py-4 text-center active:shadow-outer active:shadow-rb-green"
                  onClick={() => navigate('/project_manager/project-managers')}
                >
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}
